import React from 'react';
import { BaseAvatar } from '@/components';
import { convertBase64 } from '@/components/pages/SettingsPage/MainContent/shared/UserDetailsForm/utils';

export interface UserAvatarProps {
  avatar: string;
  setAvatar: (avatar: string) => void;
  fullName: string;
  nameInitials: string;
}

export const AvatarSection = ({ avatar, setAvatar, fullName, nameInitials }: UserAvatarProps) => {
  const fileInputRef = React.useRef<HTMLInputElement>(null);

  const onFileChange = async (event: any) => {
    event.preventDefault();
    const file = event.target.files[0];
    const fileBase64 = await convertBase64(file);
    setAvatar(fileBase64 as string);
  };

  const onBaseAvatarClick = () => fileInputRef.current?.click();

  return (
    <div className="flex flex-row w-full justify-between gap-4">
      <div className="flex flex-row items-center gap-4">
        <BaseAvatar
          initials={nameInitials}
          imageSrc={avatar}
          classNames={{ avatar: 'h-28 w-28 cursor-pointer hover:ring-2 ring-primary-500' }}
          onClick={onBaseAvatarClick}
        />

        <div>{fullName}</div>

        <input type="file" accept="image/png" ref={fileInputRef} onChange={(event) => onFileChange(event)} hidden />
      </div>
    </div>
  );
};
